import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { FaRegCheckCircle, FaExclamationTriangle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../../components/ui/ToastContext";
import { jwtDecode } from 'jwt-decode';
import dayjs from "dayjs";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import { useNavigate } from "react-router-dom";
import utc from 'dayjs/plugin/utc'
import { AiFillEdit } from "react-icons/ai";
import { API_URL } from "../../config";
import Tooltip from "@mui/material/Tooltip";
import { LuChartNoAxesColumnDecreasing, LuCircleCheck } from "react-icons/lu";
import { LuCircleX } from "react-icons/lu";
import DatePicker from "../../components/Datapicker";
import { GrValidate } from "react-icons/gr";
import { logAuditUI } from "../../utils/auditLogger";

dayjs.extend(utc);
dayjs.tz.guess();

function DashboardCard25reportviwe() {
  const { showToast } = useToast();
  const navigate = useNavigate();

  const location = useLocation();
  const { item: initialData } = location.state || {};

  useEffect(() => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Raportare',
      entityId: initialData?.report_id,
      description: `A deschis formularul de vizualizare raportare (ID: ${initialData?.report_id || ''})`,
    });
  }, []);
  const [selectedEditRowData, setSelectedEditRowData] = useState(initialData);
  const [user, setUser] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [showGrid, setShowGrid] = useState(true);
  const [Data1, setData1] = useState([]);
  const [Data2, setData2] = useState([]);
  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;
  };
  const [startDate, setStartDate] = useState(getCurrentDate());
  const [defaultOption, setDefaultOption] = useState("");
  const [selectedUsers2, setSelectedUsers2] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [product, setProduct] = useState([]);
  const [coment, setComent] = useState('');
  const [searchQuery2, setSearchQuery2] = useState('');
  const [defaultOption1, setDefaultOption1] = useState([]);
  const [defaultOption2, setDefaultOption2] = useState([]);
  const token = localStorage.getItem('jwtToken');
  const [product1, setProduct1] = useState([]);
  const [searchQuery3, setSearchQuery3] = useState('');
  const [selectedUsers3, setSelectedUsers3] = useState([]);
  const [showff, setShowff] = useState(false);
  const [survey, setSurvey] = useState([]);
  const [anssurvey, setansSurvey] = useState([]);
  const [anssurveyst, setansSurveyst] = useState([]);
  const [comments, setComments] = React.useState({});

  useEffect(() => {
    const fetchSurveyData = async () => {
      try {
        const questionsResponse = await axios.get(`${API_URL}/api/surveyquestions`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        let questions = questionsResponse.data;

        if (selectedEditRowData?.report_detail_id) {
          const answersResponse = await axios.get(`${API_URL}/api/surveyanswers/${selectedEditRowData.report_detail_id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });

          const answers = answersResponse.data;

          const convertedAnsSurvey = answers.map(item => ({
            survey_questions_id: item.survey_questions_id,
            survey_answer: item.survey_answer ? 1 : 0,
            comment: item.comment || ""
          }));

          setansSurvey(convertedAnsSurvey);

          const initialComments = {};
          answers.forEach(item => {
            if (item.comment) {
              initialComments[item.survey_questions_id] = item.comment;
            }
          });
          setComments(initialComments);

          questions = questions.map(item => {
            const matchedAnswer = answers.find(ans => ans.survey_questions_id === item.survey_questions_id);
            if (matchedAnswer) {
              return {
                ...item,
                answer: matchedAnswer.survey_answer ? 'Da' : 'Nu',
                comment: matchedAnswer.comment || ""
              };
            }
            return item;
          });
        }

        setSurvey(questions);
      } catch (error) {
        console.error("Eroare la preluarea datelor de sondaj:", error);
      }
    };

    fetchSurveyData();
  }, [selectedEditRowData]);

  useEffect(() => {
    console.log(anssurvey)
  }, [survey]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowGrid(false);
  //   }, 1000);
  //   return () => clearTimeout(timer);
  // }, []);

    useEffect(() => {
    if (user?.userId) {
      const timer = setTimeout(() => {
        setShowGrid(false);
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, [user?.userId]); 
  
  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);

      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
  }, []);

  useEffect(() => {
    if (selectedEditRowData) {
      console.log(selectedEditRowData)
      setDefaultOption(selectedEditRowData?.user_id ? selectedEditRowData?.user_id : Data2[0]?.user_id);

      axios.post(`${API_URL}/api/report/details`, { report_detail_id: selectedEditRowData?.report_detail_id }, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      })
        .then(response => {
          const datarep = response.data.data[0]?.visits[0]?.reports[0]

          if (datarep.visit_date) {
            const formattedDatestart = dayjs.utc(datarep.visit_date).format("YYYY-MM-DD");
            setStartDate(formattedDatestart);
          }

          setComent(datarep.report_comment || "");
          setIsActive(datarep.is_validated)
          const vvv = datarep.report_users_name.map((i) => i.report_user)
          const nnn = datarep.materials.map((i) => i.materials_id)
          const mmm = datarep.products.map((i) => i.product_id)
          const lll = datarep.report_pharmacist_ff.map((i) => i.pharmacist_id)
          setDefaultOption2(vvv);
          setDefaultOption1(nnn);
          setSelectedUsers2(mmm);
          setSelectedUsers3(lll)
          if (datarep?.location?.id_inst === 1058) {
            setShowff(true)
          }
          console.log(datarep)
          setData2([{
            user_id: datarep.user_id,
            start_time: datarep.report_start_time,
            end_time: datarep.report_end_time,
            obiect_id: datarep?.object_id ?? null,
            index: 1,
            obiect_type_id: datarep?.obiect_type_id ?? null,
            comment: datarep.comment || "",
            planning_detail_id: datarep?.planning_detail_id ?? null,
            report_detail_id: datarep?.report_detail_id ?? null,
            status: datarep?.planning_type_id === 1 ? "Planificat" : "Neplanificat",
            institution_id: datarep?.location?.institution_id ?? null,
            institution: datarep?.location?.institution ?? null,
            address: datarep?.location?.address ?? null,
            city_name: datarep?.location?.city ?? null,
            inst_type: datarep?.location?.inst_type ?? null,
            physician_name: datarep?.physician?.name ?? null,
            data_acord: datarep?.physician?.data_acord ?? null,
            speciality: datarep?.physician?.speciality ?? null,
            is_double_visit: datarep?.is_double_visit ?? null
          }]);
        })
        .catch(err => console.error(err));
    }
  }, [selectedEditRowData]);

  useEffect(() => {
    if (!user?.userId) return;

    const fetchMaterials = axios.get(`${API_URL}/api/materials`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const fetchProduct = axios.post(
      `${API_URL}/api/productuser`,
      { user_id: user?.userId || 0 },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const fetchManageUsers = axios.post(
      `${API_URL}/api/users/manageusers`,
      { user_id: user?.userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const fetchPharmacists = axios.get(`${API_URL}/api/pharmacistff`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    Promise.all([fetchMaterials, fetchProduct, fetchManageUsers, fetchPharmacists])
      .then(([materialsRes, productRes, manageUsersRes, pharmacistsRes]) => {
        const materials = materialsRes.data.filter((i) => i.is_active !== 0);
        setMaterials(materials);
        setProduct(productRes.data);
        setData1(manageUsersRes.data);
        setProduct1(pharmacistsRes.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [user, token]);

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const dropdownOptions = Data1.map((region) => ({
    value: region.user_id,
    label: region.user_name_surname
  }));

  const _onSelect = (selectedOption) => {
    setDefaultOption(selectedOption);
  };

  const dropdownOptions1 = materials.map((region) => ({
    value: region.materials_id,
    label: region.description
  }));

  const _onSelect1 = (value, isChecked) => {
    if (isChecked) {
      setDefaultOption1((prev) => [...prev, value]);
    } else {
      setDefaultOption1((prev) => prev.filter((item) => item !== value));
    }
  };

  const _onSelect2 = (value, isChecked) => {
    if (isChecked) {
      setDefaultOption2((prev) => [...prev, value]);
    } else {
      setDefaultOption2((prev) => prev.filter((item) => item !== value));
    }
  };

  const handleChangecom = (event) => {
    setComent(event.target.value);
  };

  const handleClick = () => {
    showToast({
      message: (
        <div>
          <p>{isActive ? 'Sigur doriți să devalidati această înregistrare?' : 'Sigur doriți să validati această înregistrare?'}</p>
          <div className="flex gap-2 mt-2">
            <button
              className="px-3 py-1 bg-red-700 text-white rounded-md"
              onClick={async () => {
                await confirmDelete1();
              }}
            >
              Da
            </button>
            <button
              className="px-3 py-1 bg-gray-400 text-white rounded-md"
              onClick={() => { anulat() }}
            >
              Nu
            </button>
          </div>
        </div>
      ),
      type: "warning",
      icon: <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-500" />,
    });
  }

  const confirmDelete1 = async () => {
    try {
      await axios.put(
        `${API_URL}/api/validatereport`,
        {
          report_id: selectedEditRowData.report_detail_id,
          is_validated: !isActive,
          submited_user_id: user?.userId,
          planning_id: selectedEditRowData.planning_id

        }
      );
      setIsActive(!isActive)
      showToast({
        message: "Datele au fost validate cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la ștergerea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const anulat = async () => {
    showToast({
      message: "Anulat",
      type: "success",
      icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      duration: 20
    });
  };

  return (
    <div>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
          <div className="col-span-full  rounded-xl ">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia nu poate fii modificata" title="Formular" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }}
                  action={
                    user && user.role !== 'User' && (
                      <div className="relative mt-4">
                        <label className="absolute z-10 -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10">Utilizator</label>
                        <select
                          className="w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500"
                          value={defaultOption}
                          onChange={(e) => _onSelect(e.target.value)}
                          disabled={true}
                        >
                          <option value="" disabled>Alege utilizator</option>
                          {dropdownOptions.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>
                    )} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="flex justify-between items-center gap-2">
                    <div className="relative" style={{ width: "30vh" }}>
                      <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                        Data
                      </label>
                      <DatePicker
                        selectedDate={startDate}
                        handleDateChange={handleStartDateChange}
                        disabled={true}
                      />
                    </div>

                    {user && user.role !== 'User' && (
                      <div className="relative">
                        <Tooltip title="Validare" arrow placement="top">
                          <button
                            className={`px-4 py-2 rounded-md text-sm font-semibold ${isActive === true
                              ? "bg-green-700 text-white"
                              : "bg-red-500 text-white"
                              }`}
                            onClick={handleClick}
                          >
                            {isActive === true ? <GrValidate size={20} /> : <GrValidate size={20} />}
                          </button>
                        </Tooltip>
                      </div>
                    )}

                  </div>
                  <div className="relative mt-4">
                    <Divider className="dark:bg-gray-400" />
                    <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex justify-between items-center">
                      <h2 className="font-semibold text-gray-800 dark:text-gray-100">Raportare detalii</h2>
                      <h2 className="font-medium text-gray-600 dark:text-gray-300">{Data2[0]?.is_double_visit ? 'Vizita Dubla/' : ""}{Data2[0]?.status}</h2>
                    </header>

                    <div className="p-3 max-xs:sr-only">
                      <div className="lg:flex w-full">
                        <div className="w-full overflow-x-auto">
                          <table className="w-full table-auto whitespace-nowrap">
                            <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                              <tr>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Interval ora</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Doctor</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Specialitatea</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Tip</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Institutia</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Adresa</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Oras</div>
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                              {Data2.map((item, idx) => {
                                return (
                                  <React.Fragment key={idx}>
                                    <tr className={`text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60 ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}>
                                      <td className="p-2 whitespace-nowrap flex items-center">
                                        {item.start_time && item.end_time && dayjs(item.start_time).isValid() && dayjs(item.end_time).isValid()
                                          ? (<span>{dayjs.utc(item.start_time).format('HH:mm')} - {dayjs.utc(item.end_time).format('HH:mm')}</span>) : (
                                            <span>{item.start_time} - {item.end_time}</span>)}
                                      </td>
                                      <td className="p-2 whitespace-nowrap">
                                        {item.obiect_type_id === 1 ? (
                                          <div className="flex items-center gap-1.5">
                                            <span>{item.physician_name || "-"}</span>
                                            {item.data_acord ? (
                                              <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                </svg>
                                              </span>
                                            ) : null}
                                          </div>
                                        ) : "-"}
                                      </td>
                                      <td className="p-2 whitespace-nowrap">{item.obiect_type_id === 1 ? item.speciality || "-" : "-"}</td>
                                      <td className="p-2 whitespace-nowrap">{item.inst_type}</td>
                                      <td className="p-2 whitespace-nowrap">{item.institution}</td>
                                      <td className="p-2 whitespace-nowrap">{item.address}</td>
                                      <td className="p-2 whitespace-nowrap">{item.city_name}</td>
                                    </tr>
                                  </React.Fragment>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <table className="w-full">
                      <tbody>
                        {Data2.map((item, idx) => {
                          return (
                            <React.Fragment key={idx}>
                              <tr>
                                <td>
                                  <div className="sm:hidden mb-4 p-3 rounded-lg bg-gray-100 dark:bg-gray-700">
                                    <div className="grid grid-cols-1 gap-2">
                                      <div className="flex items-center gap-2 p-2">
                                        <div>
                                          <div className="flex items-center">
                                            <span className="text-gray-600 dark:text-gray-300">Interval ora: </span>
                                            {item.start_time && item.end_time && dayjs(item.start_time).isValid() && dayjs(item.end_time).isValid()
                                              ? (<span>{dayjs.utc(item.start_time).format('HH:mm')} - {dayjs.utc(item.end_time).format('HH:mm')}</span>) : (
                                                <span>{item.start_time} - {item.end_time}</span>)}
                                          </div>


                                          <h3 className="text-gray-900 dark:text-gray-100 flex items-center gap-1.5">
                                            {item.obiect_type_id === 1 ? (
                                              <>
                                                <span>{item.physician_name}</span>
                                                {item.data_acord ? (
                                                  <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                    <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                    </svg>
                                                  </span>
                                                ) : null}
                                              </>
                                            ) : item.institution}
                                          </h3>

                                          <div className="text-md text-gray-500 dark:text-gray-400">
                                            {item.inst_type}
                                          </div>

                                          <div className="text-md text-gray-500 dark:text-gray-400">
                                            {item.obiect_type_id === 1 ? (item.speciality + " - " + item.institution) || "-" : null}
                                          </div>

                                          <div className="text-md text-gray-500 dark:text-gray-400">
                                            {(item.address + " - " + item.city_name) || "-"}
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </CardContent>
                <Divider className="dark:bg-gray-400" />
                <CardActions sx={{ justifyContent: 'flex-end' }}>
                </CardActions>
              </Card>
            </form>
          </div>

          <div className="flex-1  rounded-xl ">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Participanți la vizită" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative space-y-2 mt-4 max-h-[220px] overflow-y-auto">
                    {dropdownOptions.filter(option => defaultOption2.includes(Number(option.value))).length ?
                      (dropdownOptions.filter(option => defaultOption2.includes(Number(option.value))).map((option) => (
                        <div key={option.value} className="flex items-center  ml-4">
                          <input
                            type="checkbox"
                            id={option.value}
                            value={option.value}
                            checked={defaultOption2.includes(Number(option.value))}
                            onChange={(e) => _onSelect2(option.value, e.target.checked)}
                            className="ml-2 mr-2"
                            disabled={true}
                          />
                          <label htmlFor={option.value} className="text-sm">{option.label}</label>
                        </div>
                      ))) : (
                        <div className="p-4 text-center text-gray-500">
                          Nu a fost selectati participanti
                        </div>
                      )}
                  </div>
                </CardContent>
              </Card>
            </form>
          </div>

          <div className="flex-1 rounded-xl ">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Materiale" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative mt-4 ">
                    {dropdownOptions1.filter(option => defaultOption1.includes(Number(option.value))).length ? (
                      dropdownOptions1.filter(option => defaultOption1.includes(Number(option.value))).map((option) => (
                        <div key={option.value} className="flex items-center">
                          <input
                            type="checkbox"
                            id={option.value}
                            value={option.value}
                            checked={defaultOption1.includes(option.value)}
                            onChange={(e) => _onSelect1(option.value, e.target.checked)}
                            className="mr-2"
                            disabled={true}
                          />
                          <label htmlFor={option.value} className="text-sm">{option.label}</label>
                        </div>
                      ))) : (
                      <div className="p-4 text-center text-gray-500">
                        Nu a fost ales niciun material
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            </form>
          </div>

          {(Data2[0]?.obiect_type_id === 2 && showff === true) && (
            <div className="flex-1 rounded-xl ">
              <form
                onSubmit={(event) => {
                  event.preventDefault();
                }}
              >
                <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                  <CardHeader subheader="Informatia poate fii modificata" title="Cadre instruite FF" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                  <Divider className="dark:bg-gray-400" />
                  <CardContent>
                    <div className="relative mt-4">
                      {selectedUsers3?.length > 0 && (
                        <div className="mt-4">
                          <input
                            type="text"
                            className="w-full rounded-md border border-gray-300 bg-gray-100 px-3 py-2 focus:border-blue-500 focus:outline-none dark:text-gray-200 dark:bg-gray-800"
                            placeholder="Căutare Farmacist"
                            value={searchQuery3}
                            onChange={(e) => setSearchQuery3(e.target.value)}
                          />
                        </div>
                      )}


                      <div className="mt-4 max-h-[164px] overflow-y-auto">
                        <ul>
                          {selectedUsers3.length > 0 ? (
                            product1
                              .filter(user => (
                                (user.description.toLowerCase().includes(searchQuery3.toLowerCase()) ||
                                  user.user_name_surname.toLowerCase().includes(searchQuery3.toLowerCase())) &&
                                selectedUsers3.includes(user.pharmacist_id)
                              ))
                              .map(user => (
                                <li key={user.pharmacist_id} className="flex items-center gap-2 p-2 border-b">
                                  <div className="pl-4 flex flex-col">
                                    <h3 className="text-gray-900 dark:text-gray-100 flex items-center gap-1.5">
                                      <span>{user.user_name_surname}</span>
                                      {(user.data_acord === 1 || user.data_acord === true) && (
                                        <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                          <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                          </svg>
                                        </span>
                                      )}
                                    </h3>
                                    <p className="text-sm text-gray-600 dark:text-gray-200">{user.description}</p>
                                  </div>
                                </li>
                              ))
                          ) : (
                            <div className="p-4 text-center text-gray-500">
                              Nu a fost ales niciun farmacist
                            </div>
                          )}
                        </ul>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </form>
            </div>
          )}

          <div
            className={`${(Data2[0]?.obiect_type_id === 2 && showff === true) ? 'flex-1 col-span-full rounded-xl' : 'flex-1 rounded-xl'}`}
          >
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Produse" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative mt-4">
                    {selectedUsers2.length > 0 && (
                      <div className="mt-4">
                        <input
                          type="text"
                          className="w-full rounded-md border border-gray-300 bg-gray-100 px-3 py-2 focus:border-blue-500 focus:outline-none  dark:text-gray-200 dark:bg-gray-800"
                          placeholder="Căutare Produs"
                          value={searchQuery2}
                          onChange={(e) => setSearchQuery2(e.target.value)} />
                      </div>
                    )}

                    <div className="mt-4 max-h-[164px] overflow-y-auto">
                      <ul>
                        {selectedUsers2.length > 0 ? (
                          product
                            .filter(user => (
                              user.description.toLowerCase().includes(searchQuery2.toLowerCase()) &&
                              selectedUsers2.includes(user.product_id)
                            ))
                            .map(user => (
                              <li key={user.product_id} className="flex items-center gap-2 p-2 border-b">
                                <h3 className="text-gray-900 dark:text-gray-100">{user.description}</h3>
                              </li>
                            ))
                        ) : (
                          <div className="p-4 text-center text-gray-500">
                            Nu a fost ales niciun produs
                          </div>
                        )}
                      </ul>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </form>
          </div>

          <div className="col-span-full rounded-xl">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader
                  subheader="Informatia poate fii modificata"
                  title="Chestionar"
                  subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }}
                />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative mt-4">
                    <div className="relative mt-2 overflow-y-auto">
                      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                        <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm sticky top-0">
                          <tr>
                            <th scope="col" className="text-left p-2 font-semibold">Întrebare</th>
                            <th scope="col" className="text-center p-2 font-semibold">Da</th>
                            <th scope="col" className="text-center p-2 font-semibold">Nu</th>
                          </tr>
                        </thead>
                        <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                          {survey.filter((i) => i.survey_questions_type_id === (selectedEditRowData?.obiect_type_id === 1 ? 1 : 2))
                            .map((user, idx) => (
                              <React.Fragment key={user.survey_questions_id}>
                                <tr className={`text-sm ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}>
                                  <td className="px-4 py-1 whitespace-normal">
                                    <p className="text-sm text-gray-600 dark:text-gray-200">{user.survey_questions}</p>
                                    {(user.survey_questions_id === 11 || user.survey_questions_id === 27 || user.survey_questions_id === 29 || user.survey_questions_id === 23) && (
                                      <p className="text-xs text-gray-500 dark:text-gray-300">
                                        Dacă ați selectat „Da”, completați caseta cu un comentariu.
                                      </p>
                                    )}
                                  </td>
                                  <td className="px-4 py-1 text-center">
                                    <button
                                      disabled={true}
                                      className={`p-1 rounded-full ${user.answer === 'Da' ? 'text-green-500' : 'text-gray-300 dark:text-gray-600'}`}
                                      aria-label="Select Da"
                                    >
                                      <LuCircleCheck className="h-5 w-5" />
                                    </button>
                                  </td>
                                  <td className="px-4 py-1 text-center">
                                    <button
                                      disabled={true}
                                      className={`p-1 rounded-full ${user.answer === 'Nu' ? 'text-red-500' : 'text-gray-300 dark:text-gray-600'}`}
                                      aria-label="Select Nu"
                                    >
                                      <LuCircleX className="h-5 w-5" />
                                    </button>
                                  </td>
                                </tr>

                                {(user.survey_questions_id === 11 || user.survey_questions_id === 27 || user.survey_questions_id === 29 || user.survey_questions_id === 23) && user.answer === 'Da' && (
                                  <tr>
                                    <td colSpan={3}>
                                      <form onSubmit={(e) => e.preventDefault()}>
                                        <Card className="p-0 dark:bg-gray-800 dark:text-gray-100">
                                          <CardContent className="p-0">
                                            <div className="relative">
                                              <textarea
                                                disabled={true}
                                                id="message"
                                                rows="2"
                                                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="Scrie aici..."
                                                value={comments[user.survey_questions_id] || ''}
                                              />
                                            </div>
                                          </CardContent>

                                        </Card>
                                      </form>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardContent>
              </Card>


            </form>
          </div>

          <div className="col-span-full rounded-xl ">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Comentariu" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative mt-4">
                    <textarea
                      disabled={true}
                      id="message"
                      rows="2"
                      className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Scrie aici..."
                      value={coment}
                      onChange={handleChangecom} />
                  </div>
                </CardContent>
              </Card>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default DashboardCard25reportviwe;